import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';

const QuickEditTextField = props => {
  const {
    formControlProps,
    inputProps
  } = props;

  return (
    <FormControl {...formControlProps}>
      <TextField {...inputProps} />
    </FormControl>
  );
}

export default QuickEditTextField;
